import { INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_INVALID_FILE_UPLOAD, INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_RESET_INVALID_FILE_UPLOAD } from '../actions';
export const photoCaptureIntelligentEstimatorInvalidFileUploadReducer = (state, action) => {
    var _a;
    switch (action.type) {
        case INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_INVALID_FILE_UPLOAD:
            return Object.assign(Object.assign({}, state), { estimatorFileUploadError: [...((_a = state.estimatorFileUploadError) !== null && _a !== void 0 ? _a : []), action.payload.errorData] });
        case INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_RESET_INVALID_FILE_UPLOAD:
            return Object.assign(Object.assign({}, state), { estimatorFileUploadError: [] });
        default:
            return state;
    }
};
//# sourceMappingURL=photoCaptureIntelligentEstimatorInvalidFileUploadReducer.js.map